import { render } from "./Program01.vue?vue&type=template&id=aee13f80"
import script from "./Program01.vue?vue&type=script&lang=js"
export * from "./Program01.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__